document.querySelector('.back-to-top').addEventListener('click', (e) => {
    e.preventDefault();
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
});

if (document.querySelector('[href="#max-section"]')) {
    document.querySelector('[href="#max-section"]').addEventListener('click', (e) => {
        e.preventDefault();
        document.getElementById('max-section').scrollIntoView({
            top: 0,
            behavior: 'smooth',
        });
    });
}
